import type { IPlayerState } from "@pixellot/vue-player/src/util/state";
import type { VideoJsPlayer as IPixellotPlayer } from "@pixellot/web-sdk";

export interface EventPlayerRefs {
  player: Ref<IPixellotPlayer | null>;
  playerState: Ref<IPlayerState | null>;
  playerError: Ref<string | null>;
}

// Shared refs used across all components
// Player component updates these, other components read from them
const sharedRefs: EventPlayerRefs = {
  player: ref(null) as Ref<IPixellotPlayer | null>,
  playerState: ref(null) as Ref<IPlayerState | null>,
  playerError: ref(null) as Ref<string | null>,
};

export function useEventPlayer(): EventPlayerRefs {
  return sharedRefs;
}
